export default __webpack_public_path__ + "static/media/background.366c656e.jpg";